import { Typography } from '@mui/material'

interface NoDataPlaceholderProps {
    text?: string
}

const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = ({ text }) => {
    return (
        <Typography
            sx={{
                fontStyle: 'italic',
                textAlign: 'center',
                color: 'rgba(0, 0, 0, 0.6)',
                paddingBottom: '20px',
            }}
        >
            {text ?? 'No data available'}
        </Typography>
    )
}

export default NoDataPlaceholder
